export const AggridClassVariable = Object.freeze({
  filter: 'agTextColumnFilter',
  floatingFilterComponentParams: {suppressFilterButton: true},
  flex: 2,
  resizable: true,
  sortable: true,
});
